import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import useMembers from "../hooks/use-members";
import MemberForm from "../features/members/components/member-form";
import { useEffect, useState } from "react";
import { Member, MemberRequest } from "../service/model/member.model";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import * as memberSlice from "../features/members/member.slice";
import * as memberService from "../service/member.service";
import Loader from "../components/loader";
import MemberSummary from "../features/members/components/member-summary";
import MemberTable from "../features/members/components/member-table";
import SearchBox from "../components/search-box";
import { selectLoggedInUser } from "../features/auth/auth.slice";
import { S3KeyGenerator } from "../helpers/s3-helpers";
import FilterDropdown from "../components/filter-dropdown";
import useMemberships from "../hooks/use-memberships";
import CreateButton from "../components/create-button";

const Members = () => {
    const dispatch = useAppDispatch();
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);

    const [memberships] = useMemberships();
    const [showMemberForm, setShowMemberForm] = useState(false);
    const isLoading = useAppSelector(memberSlice.selectIsLoading);

    const [searchText, setSearchText] = useState('');
    const [membershipStatus, setMembershipStatus] = useState('');
    const [attendanceStatus, setAttendanceStatus] = useState('');


    const [members] = useMembers();

    const [filteredMembers, setFilteredMembers] = useState(members);

    useEffect(() => {
        if (searchText === '' && membershipStatus === '' && attendanceStatus === '') {
            setFilteredMembers(members);
        } else {
            setFilteredMembers(members.filter(item => (
                item.firstName.toLowerCase().includes(searchText.toLowerCase()) &&
                (membershipStatus === "" || item.membershipStatus === membershipStatus) &&
                (attendanceStatus === "" || item.attendanceStatus === attendanceStatus)
            )));
        }
    }, [searchText, membershipStatus, attendanceStatus, members]);

    const handleSubmit = async (data: MemberRequest, image?: File | null) => {
        if (loggedInUserDetails?.roleData.businessUser?.id) {
            const createdMember = await dispatch(memberSlice.createMember({ ...data, businessId: loggedInUserDetails?.roleData.businessUser?.id })).then((resp) => {
                if (resp.meta.requestStatus === 'fulfilled') {
                    setShowMemberForm(false);
                }
                return resp.payload as Member;
            });

            if (image) {
                const extension = image.name.split('.').pop();
                if (extension) {
                    const key = S3KeyGenerator.memberProfileImageKey(loggedInUserDetails?.roleData.businessUser?.id, createdMember.id, extension);
                    const presignedUrl = await memberService.getPresignedUrl(createdMember.id, extension);
                    await memberService.uploadProfileImageToS3(presignedUrl, image);
                    await memberService.updateMemberImageReference(createdMember.id, key);
                    dispatch(memberSlice.fetchMembers());
                }
            }
        }
    };

    function setName(name: string) {
        setSearchText(name);
    }

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {members &&
                <>
                    <MemberSummary />
                    <Grid container direction="row" style={{ marginTop: '12px' }}>
                        <Grid size={12}>
                            <Box sx={{ mt: '12px' }}>
                                <CreateButton variant="contained" onClick={() => setShowMemberForm(true)}>Add Member</CreateButton>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" style={{ marginTop: '12px', alignItems: 'center' }}>
                        {/* <FilterSection> */}
                            <Grid size={{ xs: 12, lg: 4 }}>
                                <SearchBox placeholder="Search by name" setSearchValue={setName} />
                            </Grid>
                            <Grid size={{ xs: 12, lg: 4 }}>
                                <FilterDropdown
                                    id="attendanceStatus"
                                    placeholder="Attendance Status"
                                    label="Attendance Status"
                                    defaultValue={attendanceStatus}
                                    options={[
                                        { key: 'none', value: '', label: 'All' },
                                        { key: 'active', value: 'Active', label: 'Active' },
                                        { key: 'inactive', value: 'Inactive', label: 'Inactive' },
                                    ]}
                                    onChange={(value: string) => setAttendanceStatus(value)}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, lg: 4 }}>
                                <FilterDropdown
                                    id="membershipStatus"
                                    placeholder="Membership Status"
                                    label="Membership Status"
                                    defaultValue={membershipStatus}
                                    options={[
                                        { key: 'none', value: '', label: 'All' },
                                        { key: 'active', value: 'Active', label: 'Active' },
                                        { key: 'expired', value: 'Expired', label: 'Expired' },
                                    ]}
                                    onChange={(value: string) => setMembershipStatus(value)}
                                />
                            </Grid>
                        {/* </FilterSection> */}
                    </Grid>

                    <MemberTable members={filteredMembers} />
                    {/* <MemberDataTable/> */}
                    {showMemberForm &&
                        <MemberForm member={undefined} editable={true} onClose={() => setShowMemberForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    );
}

export default Members;